// extracted by mini-css-extract-plugin
export default {"pagination":"_1bdbf5aca6","pageItem":"_8baf97074e _6636a8874a _70ad4064a3","active":"_03d289ed09","disabled":"_7835542b6a","arrowIcon":"_3adbc0fdb5"};